import { useEffect, useState } from "react"

export enum AppLanguage {
    RU = 'ru',
    EN = 'en',
    DE = 'de',
    FR = 'fr',
    ES = 'es',
    ZH_CN = 'zh-cn',
    ZH_TW = 'zh-tw',
}

export type LanguageHookResult = {
    main: AppLanguage
    full: string
}

export const useLanguage = (): LanguageHookResult => {
    const [main, setMain] = useState(AppLanguage.EN)
    const [full, setFull] = useState<string>(AppLanguage.EN)

    useEffect(() => {
        const fullLanguage = shortenLanguage(getLanguage())
        const appLanguage = getAppLanguage(fullLanguage)

        setMain(appLanguage)
        setFull(fullLanguage)
    }, [])

    return { main, full }
}

const DefaultLanguage = 'en'
const getLanguage = (): string => {
    if (navigator == null) {
        return DefaultLanguage
    }

    if (navigator.language) {
        return navigator.language
    }

    if (navigator.languages && navigator.languages.length > 0) {
        return navigator.languages[0]
    }

    // @ts-ignore
    if (navigator.userLanguage) {
        // @ts-ignore
        return navigator.userLanguage
    }

    // @ts-ignore
    if (navigator.browserLanguage) {
        // @ts-ignore
        return navigator.browserLanguage
    }

    return DefaultLanguage
}

const shortenLanguage = (lang: string): string => {
    if (lang.startsWith("zh")) {
        if (lang.toLowerCase().includes("hant") || lang.toLowerCase().includes("tw")) {
          return "zh-TW"
        } else {
          return "zh-CN"
        }
      }
  
      return lang.slice(0, 2)
}

const getAppLanguage = (language: string): AppLanguage => {
    const parts = language.split('_')
    if (parts.length > 1) {
        const country = parts[0].toLowerCase() as AppLanguage
        if (Object.values(AppLanguage).includes(country)) {
            return country
        }

        return DefaultLanguage as AppLanguage
    }

    const preparedLanguage = language.toLowerCase() as AppLanguage
    if (Object.values(AppLanguage).includes(preparedLanguage)) {
        return preparedLanguage
    }

    return DefaultLanguage as AppLanguage
}